import { activeUserListConstants } from "../_constants";

export default function activeUserList(state = {}, action) {
    switch (action.type) {
        case activeUserListConstants.GET_ACTIVE_USER_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case activeUserListConstants.GET_ACTIVE_USER_LIST_SUCCESS:
            return {
                ...state,

                loading: false,
                getActiveUserList: action?.user
            };
        case activeUserListConstants.GET_ACTIVE_USER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

            //GET DASHBOARD DATA
            case activeUserListConstants.GET_SHOWDASHBOARD_DATA_REQUEST:
                return {
                    ...state,
                    loading: true
                };
            case activeUserListConstants.GET_SHOWDASHBOARD_DATA_SUCCESS:
                return {
                    ...state,
    
                    loading: false,
                    getDashBoardData: action?.user
                };
            case activeUserListConstants.GET_SHOWDASHBOARD_DATA_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: action.error
                };

//Udate user status
        case activeUserListConstants.UPDATE_USER_STATUS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case activeUserListConstants.UPDATE_USER_STATUS_SUCCESS:
            return {
                ...state,

                loading: false,

            };
        case activeUserListConstants.UPDATE_USER_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state
    }
}